// extracted by mini-css-extract-plugin
module.exports = {"base":"Base_base__15YNo","content":"Base_content__3l7DG","scrollTopBtn":"Base_scrollTopBtn__28XyA"};